<div class="row">
  <div class="co-12 col-lg-6 m-b-30">
    <fui-heading [text]="keyType == 'oem' ? 'OEM Key Import' : '3rd Party License Import'" [level]="5"></fui-heading>
    @if (loading) {
      <myp-inline-loader [loading]="loading" height="200px" spinnerName="keygenloader"></myp-inline-loader>
    }
    @if (!loading) {
      @if (!uploadingComplete) {
        <div class="form-group">
          <label class="control-label" for="provider">{{ keyType == "oem" ? "Provider" : "Product" }}</label>
          @if (keyType == "oem") {
            <select class="form-control" id="provider" name="provider" [(ngModel)]="provider" (ngModelChange)="providerChange($event)">
              <option value="-1">Select a Provider</option>
              @for (id of data["String IDs"]; track id) {
                <option>{{ id }}</option>
              }
            </select>
          }
          @if (keyType == "tpl") {
            <select class="form-control" id="provider" name="provider" [(ngModel)]="provider" (ngModelChange)="providerChange($event)">
              <option value="-1">Select a Product...</option>
              @for (item of data.flatProducts; track item) {
                <option [value]="item.id">{{ item.title }}</option>
              }
            </select>
          }
        </div>
        @if (provider != "-1") {
          <div class="form-group">
            @if (!uploader || (!uploader.queue.length && !uploadingComplete)) {
              <div ng2FileDrop class="content-bg content-drop-zone m-b-20" [class.hovering]="hasBaseDropZoneOver" (fileOver)="fileOverBase($event)" [uploader]="uploader">
                <div>{{ (hasBaseDropZoneOver ? "profile.edit.dropit" : "profile.edit.drophere") | translate }}</div>
              </div>
            }
            @if (uploadingFile) {
              <div class="content-bg m-b-20 d-flex justify-content-between align-items-center">
                <span class="brandfont-black">{{ uploadingFile.file.name }}</span>
                <button class="btn btn-sm btn-secondary" (click)="clearFile()">Remove</button>
              </div>
            }
            @if (uploadingFile) {
              <button class="btn btn-primary" (click)="upload()">Upload</button>
            }
          </div>
        }
      }
      @if (uploadingComplete) {
        <div class="text-center m-t-30">
          <fa-icon class="c-green" style="font-size: 50px" icon="circle-check"></fa-icon>
          <br />
          <span class="brandfont-black t-16">Uploading Complete!</span>
          <br />
          Your file has been uploaded and is being processed. The keys will be imported automatically.
          <br />
          <br />
          <span class="btn btn-sm btn-secondary" (click)="clearFile()">Done</span>
        </div>
      }
    }
  </div>
  @if (!loading) {
    <div class="col-12 col-lg-6">
      <fui-heading [text]="'Remaining Keys'" [level]="5"></fui-heading>
      <div class="row t-14">
        <div class="col-6 m-b-20">
          <strong>{{ keyType == "oem" ? "Provider" : "Product" }}</strong>
        </div>
        <div class="col-6 m-b-20"><strong>Remaining Keys</strong></div>
        @for (key of data.Statistic | keyvalue; track key) {
          <div class="col-6" [class.c-red]="key.value == 0">{{ key.key }}</div>
          <div class="col-6" [class.c-red]="key.value == 0">{{ key.value }}</div>
          <div class="col-12">
            <hr class="m-y-10" />
          </div>
        }
      </div>
    </div>
  }
</div>
